@if (channel) {
  <shared-modal [mobile]="sharedService.screenSize !== 'l'">
    <!-- header -->
    <h2 slot="header">Iniciar aquecimento</h2>

    <!-- body -->
    <div class="flex flex-col gap-3">
      <input
        placeholder="Nome"
        [value]="channel.name || null"
        (input)="setName($event.target)"
        [disabled]="loading"
      />
      <div class="grid gap-[--gap-m] [grid-template-columns:80px_80px_1fr]">
        <input
          no-clear
          placeholder="País"
          maxlength="2"
          [value]="number.countryCode"
          (input)="setNumber('countryCode', $event, 3)"
          [disabled]="loading"
        />
        <input
          no-clear
          placeholder="DDD"
          maxlength="2"
          [value]="number.areaCode"
          (input)="setNumber('areaCode', $event, 2)"
          [disabled]="loading"
        />
        <input
          no-clear
          placeholder="Número"
          maxlength="8"
          [value]="number.number"
          (input)="setNumber('number', $event, 8)"
          [disabled]="loading"
        />
      </div>
    </div>

    <!-- footer -->
    <button
      slot="footer"
      class="secondary"
      (click)="sharedService.closeModal(route)"
      [disabled]="loading"
    >
      Cancelar
    </button>
    <button
      slot="footer"
      [disabled]="!channel.name || !channel.numbers.length || loading"
      (click)="save()"
    >
      {{ loading ? 'Salvando...' : 'Confirmar' }}
    </button>
  </shared-modal>
}
